import { ClipLoader } from "react-spinners";

const Spinner = () => {
  return (
    <div className="flex flex-col items-center py-8">
      <ClipLoader size={40} color="#0F766E" />
    </div>
  );
};

export default Spinner;
